// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"F7-z","categoryName":"G7-z","categoryImage":"H7-z","categoryContent":"I7-z","bottomAligned":"J7-z"};